import { goto } from "./logout.goto";
export * from "./LogoutRoutes";

export const logoutRoute = {
  goto: goto,
};
